module.exports = __webpack_public_path__ + "e-learning-app/static/img/shoucang.5e47150.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/tiku/shoucang.png
// module id = lnyz
// module chunks = 1